<div class="container" *ngIf="showVersion()">
	<div class="environment {{env}}">
		{{env}}
	</div>
	<div class="version" (click)="openEndpointVersions()" *ngIf="includeVersion">{{version}}</div>
</div>
